import React, { useState, useEffect } from "react";
import axios from "axios";
import "./ContractSearch.css"; // Import the external CSS file
import api from "../pages/chat/api";

const ContractSearch = ({ onDocumentSelect }) => {
    const [searchQuery, setSearchQuery] = useState("");
    const [documents, setDocuments] = useState([]);
    
    const [showDropdown, setShowDropdown] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [selectedDocuments, setSelectedDocuments] = useState([]);
    const [contractKey, setContractKey] = useState("");
    const [contractUrl, setContractUrl] = useState("");
    const [documentType, setdocumentType] = useState("");

    

    const fetchContracts = async (query = "") => {
        

        setLoading(true);
        setError(null);

        const url = query
  ? `api/v1/copilot/all-docs/?search=${query}`
  : `api/v1/copilot/all-docs/`;

try {
  const response = await api.get(url); 

            const contracts = response.data.all_documents.contracts || [];

            // Map the contracts to include necessary fields
            const contractDocuments = contracts.map((doc) => ({
                ...doc,
                url: doc.url,
                type: doc.document_type,
            }));

            setDocuments(contractDocuments);
        } catch (error) {
            console.error("Error fetching contracts:", error);
            setDocuments([]);
            setError("Failed to fetch documents. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const handleDocumentSelect = (doc) => {
        setSelectedDocuments((prevSelected) => [...prevSelected, doc]);
        setContractKey(doc.key);
        setContractUrl(doc.url);
        setdocumentType(doc.document_type);

        if (onDocumentSelect) {
            onDocumentSelect(doc); // Pass the doc to the parent if needed
        }

        setSearchQuery("");
        setShowDropdown(false);
    };

    const handleRemoveDocument = (doc) => {
        setSelectedDocuments((prevSelected) =>
            prevSelected.filter((selectedDoc) => selectedDoc.key !== doc.key)
        );
    };

    // Always show the dropdown and fetch contracts (even if query is empty)
    const handleSearchChange = (e) => {
        const query = e.target.value;
        setSearchQuery(query);
        setShowDropdown(true);
        fetchContracts(query);
    };

    const handleInputBlur = () => {
        // Delay hiding the dropdown to allow click on items
        setTimeout(() => {
            setShowDropdown(false);
        }, 200);
    };

    const handleDropdownMouseDown = (e) => {
        // Prevent the blur event when clicking inside the dropdown
        e.preventDefault();
    };

    // Compute filtered documents based on search query
    const filteredDocs = documents.filter((doc) =>
        doc.name.toLowerCase().includes(searchQuery.toLowerCase())
    );

    return (
        <div className="contract-search-container">
            {selectedDocuments.length === 0 && (
                <>
                    <img src="searchAICP.svg" alt="Search Icon" className="search-icon" />
                    <input
                        type="text"
                        placeholder="Search Contracts"
                        className="search-input"
                        value={searchQuery}
                        onChange={handleSearchChange}
                        onFocus={() => {
                            setShowDropdown(true);
                            // If searchQuery is empty, load full list of contracts.
                            if (!searchQuery) fetchContracts("");
                        }}
                        onBlur={handleInputBlur}
                    />
                </>
            )}

            {/* Selected Documents */}
            <div className="selected-docs-container">
                {selectedDocuments.map((doc, index) => (
                    <div
                        key={index}
                        className="selected-doc-button selected-doc-button-style"
                        role="option"
                    >
                        <span className="truncate">{doc.name}</span>
                        <button
                            onClick={() => handleRemoveDocument(doc)}
                            className="remove-doc-button"
                        >
                            ×
                        </button>
                    </div>
                ))}
            </div>

            {/* Dropdown */}
            {showDropdown && (
                <div className="dropdown-wrapper">
                    <div
                        className="dropdown-container"
                        role="listbox"
                        onMouseDown={handleDropdownMouseDown}
                    >
                        {/* Arrow at the bottom */}
                        <div className="dropdown-arrow-container">
                            <div className="dropdown-arrow"></div>
                        </div>


                        {/* Header (fixed) */}
                        <div className="dropdown-header-wrapper">
                            <h1 className="dropdown-header">Select Contract</h1>
                        </div>

                        {/* Scrollable content */}
                        <div className="dropdown-scroll-content">
                            {loading ? (
                                <div className="loading-text">Loading...</div>
                            ) : error ? (
                                <div className="error-text">{error}</div>
                            ) : filteredDocs.length > 0 ? (
                                filteredDocs.map((doc) => (
                                    <button
                                        key={doc.key}
                                        className="dropdown-item-button"
                                        onClick={() => handleDocumentSelect(doc)}
                                    >
                                        <img
                                            src="/ai-object-document-icon.svg"
                                            alt="document icon"
                                        />
                                        <span className="truncate">{doc.name}</span>
                                    </button>
                                ))
                            ) : (
                                <div className="no-contracts-text">No Contracts found</div>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ContractSearch;
